import axios from "axios";
import { isTokenExpired, clearSessionAndRedirect } from "./utils/tokenValidator";

const http = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/auth`,
  headers: {
    "Content-type": "application/json"
  }
});

// Add a request interceptor to include the Bearer token
http.interceptors.request.use(
  (config) => {
    if (typeof window !== "undefined") {
      const host = window.location.hostname;
      if ((host === 'localhost' || host === '127.0.0.1') && typeof sessionStorage !== 'undefined') {
        const tenant = sessionStorage.getItem('__typogram_tenant');
        if (tenant) {
          config.headers["X-Tenant-Host"] = tenant + ".typogram.in";
        } else {
          config.headers["X-Tenant-Host"] = host;
        }
      } else {
        config.headers["X-Tenant-Host"] = host;
      }
    }
    const userStr = localStorage.getItem("user");
    if (!userStr) {
      return config;
    }

    try {
      const user = JSON.parse(userStr);
      if (user && user.accessToken) {
        if (isTokenExpired(user.accessToken)) {
          clearSessionAndRedirect();
          return Promise.reject(new Error('Token expired'));
        }
        config.headers.Authorization = `Bearer ${user.accessToken}`;
      }
    } catch (error) {
      console.error('Error parsing user from localStorage:', error);
      localStorage.removeItem("user");
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth endpoints where 401 means "wrong credentials", not "expired session"
const AUTH_ENDPOINTS = ['signin', 'signup', 'signup/send-otp', 'google', 'sso/', 'validate', 'refresh'];

http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      const requestUrl = error.config?.url || '';
      const isAuthEndpoint = AUTH_ENDPOINTS.some(ep => requestUrl.includes(ep));
      if (!isAuthEndpoint) {
        clearSessionAndRedirect();
      }
    }
    return Promise.reject(error);
  }
);

export default http;